import classNames from 'classnames';
import * as React from 'react';
import { Link } from 'react-router';

import { Icon } from '..';
import type { IColorModifier } from '../ColorHelper';
import { getColorModifierClasses } from '../ColorHelper';

export interface IMenuListItemProps extends IColorModifier {
	value?: string;
	isSelected?: boolean;
	isHidden?: boolean;
	icon?: string;
	preTextElement?: React.ReactNode;
	to?: string;
	iconWhenSelected?: string;
	onSelect?: (isSelected: boolean, id?: any) => void;
	className?: string;
	id?: any;
}

export default class IconToggle extends React.PureComponent<
	IMenuListItemProps,
	{}
> {
	public onSelect = (e?) => {
		const { onSelect, id, isSelected } = this.props;

		if (onSelect) {
			if (id !== undefined && id !== null) {
				onSelect(!isSelected, id);
			} else {
				onSelect(!isSelected);
			}
		}

		e.stopPropagation();
	};

	public render() {
		const {
			to,
			icon,
			preTextElement,
			iconWhenSelected,
			isHidden,
			value,
			className,
			isSelected,
			onSelect,
			...others
		} = this.props;

		if (isHidden) {
			return null;
		}

		const iconClasses = classNames(
			'fa',
			isSelected ? `fa-${iconWhenSelected}` : `fa-${icon}`
		);

		const iconElement = icon && (
			<Icon>
				<i className={iconClasses} />
			</Icon>
		);

		const linkClasses = classNames(getColorModifierClasses(this.props));

		return (
			<div className={className}>
				<Link
					to={to}
					onClick={this.onSelect}
					className={linkClasses}
					{...others}
				>
					{iconElement}
					{preTextElement}
					{preTextElement && value ? ' ' : ''}
					{value}
				</Link>
				{this.props.children}
			</div>
		);
	}
}
